import { FC } from 'react'

import { Carat } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import { EmbroideryService } from '../../../containers/EmbroideryService'
import { EmbroideryModalService } from '../../../containers/EmbroideryService/EmbroideryModalService'
import { trackEvent } from '../../../lib/analytics'
import { PriceText } from '../../pages/products/ProductPage/DetailsSection/EmbroiderySection/EmbroiderySection.styles'

import { CtaText, RightSideContent, EmbroideryCta as StyledEmbroideryCta } from './styles'

interface Props {
  showLowestPrice?: boolean
}

export const EmbroideryCta: FC<Props> = ({ showLowestPrice }) => {
  const {
    priceRange: { lowestPrice },
  } = EmbroideryService.useContainer()

  const { openEmbroideryModal } = EmbroideryModalService.useContainer()
  const { embroidery: strings } = useTranslation()

  return (
    <StyledEmbroideryCta
      onClick={event => openEmbroideryModal({ triggerElement: event.currentTarget })}
      {...trackEvent({ category: 'embroidery', action: 'add' })}
      aria-label='Add Embroidery'
      type='button'
    >
      <CtaText>{strings.cta}</CtaText>
      <RightSideContent>
        {showLowestPrice && (
          <CtaText>
            {strings.from} <PriceText>{lowestPrice}</PriceText>
          </CtaText>
        )}
        <Carat />
      </RightSideContent>
    </StyledEmbroideryCta>
  )
}
